import { render, staticRenderFns } from "./test-widget-control.vue?vue&type=template&id=1f6aba04&scoped=true&"
import script from "./test-widget-control.vue?vue&type=script&lang=js&"
export * from "./test-widget-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6aba04",
  null
  
)

export default component.exports